import { useEffect } from 'react'

import AttachmentList, {
  AttachmentListProps,
} from 'components/issue/common/AttachmentList'

const VideoAsAttachmentList = ({
  fieldValue,
  mediaData,
  toggleDelete,
  onLoad,
}: AttachmentListProps & {
  onLoad?: () => void
}) => {
  useEffect(() => {
    if (onLoad) {
      onLoad()
    }
  }, [onLoad])

  return (
    <AttachmentList
      fieldValue={fieldValue}
      mediaData={mediaData}
      toggleDelete={toggleDelete}
    />
  )
}

export default VideoAsAttachmentList
